import { css } from '@emotion/css';
import { theme } from 'Shared/ThemeProvider';
import { specialOptions, contentOptions } from 'Shared/backend/widgets/Content';
import { Show,Match,Switch, For } from 'solid-js';
import { useUrls } from 'Shared/UrlProvider';
import { useStore } from 'Shared/StoreProvider';

const missingStyle = () => css({
	color: theme().palette.error
});


export function ComponentTitle(P)
{
//TODO Posters - add type
//TODO Popup - look at
//TODO in some case could add titles or extra info if available
//     If necessary could limit depth.
//XXX cf adjacent, overlay, decorator... maybe remove these labels... esp when children are specified?
//       Alt - replace then with icons
//XXX multiple line headers might be OK

//					{index() > 0 ? ' • ' : ' - '}

//XXX MAYBE try replacing Image, Grid, etc with icons? 

//TODO Remove  •s from around images in ComponentTitle

	return (<>
		<Switch>
			<Match when={P.name}>
				{P.name}
			</Match>
			<Match when={P.layout=='styles'}>
				<Require content={P.content}/>
			</Match>
			<Match when={P.layout=='link'}>
				<Require content={P.content}/>
			</Match>
			<Match when={P.layout=='grid'}>
				Grid
				{P.items?.length > 0 ? ' - ' : ''}
				<Items items={P.items} />
			</Match>
			<Match when={P.layout=='text'}>
				{stripTags(P.text)}
			</Match>
			<Match when={P.layout=='vertical'}>
				<Items items={P.items} />
			</Match>
			<Match when={P.layout=='overlay'}>
				<Require content={P.background}/> {' • '} <Require content={P.foreground}/>
			</Match>
			<Match when={P.layout=='visualWithInfo'}>
				<Show when={P.upper}>
					<Require content={P.upper} /> 
					{' • '} 
				</Show>
				<Require content={P.visual}/> 
				{' • '} 
				<Require content={P.lower} /> 
			</Match>
			<Match when={P.layout=='slides'}>
				<Items items={P.slides} />
			</Match>
			<Match when={P.layout=='image'}>
				<ImageIcon {...P} />
			</Match>
			<Match when={P.layout=='posters'}>
				{contentTitle(P.type,P.specialsType,P)}
			</Match>
			<Match when={P.layout=='buttons'}>
				Buttons
				{P.buttons?.length > 0 ? ' - ' : ''}

				<For each={P.buttons}>{(button,index) => <>
					{index() > 0 ? ' • ' : ''}
					{button.text ?? 'Button'}
				</>}</For>
			</Match>
			<Match when={P.layout=='popup'}>
				Popup
			</Match>
			<Match when={P.layout=='embed'}>
				Embed
			</Match>
		</Switch>
	</>);
}

function contentTitle(type,specialsType,P)
{
	if (!type)
		return '(unspecified)';
	if (type!='specials' || !specialsType)
		return contentOptions[type];
	return contentOptions[type] + ' - ' + specialOptions()[specialsType];
}

export function Items(P)
{
	return (
		<For each={P.items}>{(item,index) => <>
			{index() > 0 ? ' • ' : ''}
			<Require content={item} /> 
		</>}</For>
	);
}

function Require(P)
{
	return (
		<Show when={P.content} fallback={<Missing/>}>
			<ComponentTitle {...P.content} />
		</Show>
	);
}

function Missing()
{
	return <span class={missingStyle()}>Missing</span>;
}

const htmlEntities: Record<string,string> = {
	'&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&apos;': "'",
	'&nbsp;': ' ', '&mdash;': '—', '&ndash;': '–', '&hellip;': '…',
	'&laquo;': '«', '&raquo;': '»', '&ldquo;': '\u201C', '&rdquo;': '\u201D',
	'&lsquo;': '\u2018', '&rsquo;': '\u2019',
};

function stripTags(html:string)
{
	if (!html)
		return '';
	return html
		.replace(/<[^>]*>?/gm, ' ')
		.replace(/&[a-z]+;/gi, e => htmlEntities[e] ?? ' ')
		.replace(/&#(\d+);/g, (_,code) => String.fromCharCode(Number(code)))
		.replace(/&#x([0-9a-f]+);/gi, (_,code) => String.fromCharCode(parseInt(code,16)));
}


/* From Font Awesome */
function ImageIcon(P)
{
	const sw = useStore();

	return (
		<Switch>
			<Match when={P.image?.formats?.tiny}>
				<img class={css({height:42,verticalAlign:'middle'})} src={useUrls().createVenueImageUrl(P.image?.hash,P.image,sw.imageFolder,'tiny')} />
			</Match>
			<Match when={true}>
				<svg style={{width:'1.4em',fill:'#999','vertical-align':'middle'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM272 224c8.4 0 16.1 4.4 20.5 11.5l88 144c4.5 7.4 4.7 16.7 .5 24.3S368.7 416 360 416L88 416c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8l56-80c4.5-6.4 11.8-10.2 19.7-10.2s15.2 3.8 19.7 10.2l26.4 37.8 61.4-100.5c4.4-7.1 12.1-11.5 20.5-11.5z"/></svg>
			</Match>
		</Switch>
	);
}

